// extracted by mini-css-extract-plugin
module.exports = {"J_10":"Q_J_10__pvw1c"};